import { menuGroup, menuItem } from "modules/helpers";

// components
import NotificationStack from "./NotificationStack.doc";

const components = [
  menuItem("<NotificationStack/>", "notification-stack", NotificationStack),
];

// action creators
import NotifyError from "./NotifyError.doc";
import NotifyInfo from "./NotifyInfo.doc";
import NotifySuccess from "./NotifySuccess.doc";
import NotifyWarning from "./NotifyWarning.doc";
import AddNotification from "./AddNotification.doc";
import RemoveNotification from "./RemoveNotification.doc";
import RemoveAllNotifications from "./RemoveAllNotifications.doc";

const actionCreators = [
  menuItem("notifyError", "notify-error", NotifyError),
  menuItem("notifyInfo", "notify-info", NotifyInfo),
  menuItem("notifySuccess", "notify-success", NotifySuccess),
  menuItem("notifyWarning", "notify-warning", NotifyWarning),
  menuItem("addNotification", "add-notification", AddNotification),
  menuItem("removeNotification", "remove-notification", RemoveNotification),
  menuItem(
    "removeAllNotifications",
    "remove-all-notifications",
    RemoveAllNotifications
  ),
];

export default [
  menuGroup("Components", "components", components),
  menuGroup("Action Creators", "action-creators", actionCreators),
];
